import React, { useState, useEffect } from 'react';

import './CountdownTimer.sass';
import { ReactComponent as Clock } from '../static/img/clock.svg';

export default ({ cssClassName, expiredAction, durationMinutes }) => {
  const [timeRemaining, setTimeRemaining] = useState(durationMinutes * 60 * 1000);

  useEffect(() => {
    const expirationTime = new Date().getTime() + (durationMinutes * 60 * 1000);
    const countdownInterval = setInterval(() => {
      const currentTime = new Date().getTime();
      let remainingTime = expirationTime - currentTime;

      if (remainingTime <= 0) {
        remainingTime = 0;
        clearInterval(countdownInterval);
        expiredAction();
      }

      setTimeRemaining(remainingTime);
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, []);

  const formatTime = time => {
    let seconds = Math.floor((time / 1000) % 60);
    let minutes = Math.floor((time / (1000 * 60)) % 60);

    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    return minutes + ':' + seconds;
  };

  return <div className={`countDownTimer ${cssClassName}`}>
            <p className="clock">
              <Clock />
               Booking time remaining: {formatTime(timeRemaining)}
            </p>
          </div>;
};
